// KB-7219: temp solution to disable Enter press as it's causing user confusion
export const onKeyDownPreventEnter = (e: React.KeyboardEvent) => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
};

// scroll on close will be triggered on scroll the menu list, therefore
// we need to manually prevent such behavior
export const MENU_LIST_CLASSNAME = 'CustomMenuList';
export const closeMenuOnScrollOutside = (e: Event) => {
  const scrolledElement: HTMLElement = e.target as HTMLElement;
  if (!scrolledElement) {
    return false;
  }
  return !scrolledElement.className.includes(MENU_LIST_CLASSNAME);
};
